<template>
  <div class="loader-container">
    <div class="loader">
      <img :src="image" />
    </div>
  </div>
</template>

<script>
export default {
  name: "fcwpLoader",
  props: ["image"],
}
</script>
<style lang="scss">

.loader-container {
  background-color: rgba(235,235,235,0.7);
  width: 100vw;
  height: calc(100vh + 1.17vw);
  position: fixed;
  top: -1.17vw;
  z-index: 50000
}

.loader {
  top: calc(50vh - 14vw);
  max-width: 50vw;
  max-height: 50vw;
  margin: 50px auto;
  width: 28.6vw;
  height: 28.6vw;
  opacity: 0.45;
  position: relative;
  -webkit-animation: loading .8s infinite ease-in-out;
  animation: loading 1.3s infinite ease-in-out;
  img {
    width: 100%;
    height: 100%;
    -webkit-mask-image: -webkit-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 5%, rgba(0,0,0,1) 95%, rgba(0,0,0,0) 100%);
  }
}

@-webkit-keyframes loading {
  0% { clip-path: polygon(0 0, 100% 0%, 100% 0%, 0 0%); }
  5% { clip-path: polygon(0 0, 100% 0%, 100% 10%, 0 10%); }
  65% { clip-path: polygon(0 90%, 100% 90%, 100% 100%, 0 100%); }
  70% { clip-path: polygon(0 100%, 100% 100%, 100% 100%, 0 100%); }
  100% { clip-path: polygon(0 100%, 100% 100%, 100% 100%, 0 100%); }
  
}

@keyframes loading {
  0% { clip-path: polygon(0 0, 100% 0%, 100% 0%, 0 0%); }
  5% { clip-path: polygon(0 0, 100% 0%, 100% 10%, 0 10%); }
  65% { clip-path: polygon(0 90%, 100% 90%, 100% 100%, 0 100%); }
  70% { clip-path: polygon(0 100%, 100% 100%, 100% 100%, 0 100%); }
  100% { clip-path: polygon(0 100%, 100% 100%, 100% 100%, 0 100%); }
  
}

@media (max-width: 700px) {
  .loader {
    width: 50vw;
    height: 50vw;
    top: calc(50vh - 25vw);
  }
  
}


</style>